module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksFurtherSettingsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.lang.CFM000))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.OnlineState),
      expression: "settings.OnlineState"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.OnlineState) ? _vm._i(_vm.settings.OnlineState, null) > -1 : (_vm.settings.OnlineState)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.OnlineState,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "OnlineState", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "OnlineState", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "OnlineState", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM001))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.LocationFree),
      expression: "settings.LocationFree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.LocationFree) ? _vm._i(_vm.settings.LocationFree, null) > -1 : (_vm.settings.LocationFree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.LocationFree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "LocationFree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "LocationFree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "LocationFree", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM002))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceSince),
      expression: "settings.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsStartDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceUntil),
      expression: "settings.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsEndDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsBasePayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsBasePayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstanceBasePayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstanceBasePayment", $$v)
      },
      expression: "settings.SurveyInstanceBasePayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsPlusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsPlusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstancePlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstancePlusPayment", $$v)
      },
      expression: "settings.SurveyInstancePlusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CFM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(_vm.totalPayment, "EUR")))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.settings.SurveyInstanceSkillLevel),
      expression: "settings.SurveyInstanceSkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveyInstanceSkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.settings, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CFM018) + "\n                "), (_vm.survey.SurveySkillLevel > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.survey.SurveySkillLevel) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })], 2)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n            1 → " + _vm._s(_vm.lang.CFM015) + "\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            5 → " + _vm._s(_vm.lang.CFM016) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM008) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM012) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSettings()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM010) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ec6f7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/AddChecksFurtherSettingsModal.vue
// module id = 618
// module chunks = 1 2